export default [
  // Hogwarts
  {
    id: '30000',
    name: 'Transfiguration',
    type: 'Class',
    teacherId: '20001',
    purchaserId: '10011',
  },
  {
    id: '30001',
    name: 'Potions',
    type: 'Class',
    teacherId: '20000',
    purchaserId: '10011',
  },
  {
    id: '30002',
    name: 'Defense Against the Dark Arts',
    type: 'Class',
    teacherId: '20007',
    purchaserId: '10011',
  },
  {
    id: '30003',
    name: 'Herbology',
    type: 'Class',
    teacherId: '20006',
    purchaserId: '10011',
  },
  {
    id: '30004',
    name: 'Charms',
    type: 'Class',
    teacherId: '20006',
    purchaserId: '10011',
  },
  {
    id: '30005',
    name: 'Ancient Runes',
    type: 'Class',
    teacherId: '20003',
    purchaserId: '10011',
  },
  {
    id: '30006',
    name: 'Muggle Studies',
    type: 'Class',
    teacherId: '20004',
    purchaserId: '10011',
  },
  {
    id: '30007',
    name: 'Astronomy',
    type: 'Class',
    teacherId: '20002',
    purchaserId: '10011',
  },
  // Greendale Community
  {
    id: '2009001',
    name: 'Ladders',
    code: 'KAIEJ',
    teacherCount: 2,
    studentCount: 17,
    teacherId: '200901',
    studentId: '200950',
    purchaserId: '10002',
  },
  {
    id: '2009002',
    name: 'Sailing',
    code: 'APNTH',
    teacherCount: 1,
    studentCount: 6,
    teacherId: '200901',
    studentId: '200951',
    purchaserId: '10002',
  },
  {
    id: '2009003',
    name: 'Baby Talk',
    code: 'GEYSJ',
    teacherCount: 2,
    studentCount: 12,
    teacherId: '200901',
    studentId: '200952',
    purchaserId: '10002',
  },
  {
    id: '2009004',
    name: 'Can I Fry That?',
    code: 'PWJEN',
    teacherCount: 1,
    studentCount: 27,
    teacherId: '200901',
    studentId: '200953',
    purchaserId: '10002',
  },
  {
    id: '2009005',
    name: 'Sleep Lab',
    code: 'QOQJQ',
    teacherCount: 1,
    studentCount: 15,
    teacherId: '200901',
    studentId: '200954',
    purchaserId: '10002',
  },
  {
    id: '2009006',
    name: 'Grifting 101',
    code: 'PAMJE',
    teacherCount: 1,
    studentCount: 30,
    teacherId: '200901',
    studentId: '200955',
    purchaserId: '10002',
  },
  {
    id: '2009007',
    name: 'Anthropology',
    code: 'AMEUB',
    teacherCount: 3,
    studentCount: 8,
    teacherId: '200901',
    studentId: '200956',
    purchaserId: '10002',
  },
  {
    id: '2009008',
    name: 'Conspiracy Theories In U.S. History',
    code: 'NEWWO',
    teacherCount: 3,
    studentCount: 18,
    teacherId: '200901',
    studentId: '200957',
    purchaserId: '10002',
  },
  {
    id: '2009009',
    name: 'Nicholas Cage: Good Or Bad',
    code: 'NCGOB',
    teacherCount: 2,
    studentCount: 16,
    teacherId: '200901',
    studentId: '200958',
    purchaserId: '10002',
  },
  {
    id: '2009010',
    name: "Who Indeed: A Critical Analysis Of Television's Who's The Boss?",
    code: 'WHOTB',
    teacherCount: 1,
    studentCount: 13,
    teacherId: '200901',
    studentId: '200959',

    purchaserId: '10002',
  },

  // June Bauer
  {
    id: '2009011',
    name: 'English 10A',
    code: 'ONWUR',
    teacherCount: 1,
    studentCount: 19,
    teacherId: '200904',
  },
  {
    id: '2009012',
    name: 'English 10D',
    code: 'PWMDY',
    teacherCount: 2,
    studentCount: 22,
    teacherId: '200904',
  },
  {
    id: '2009013',
    name: 'English 11B',
    code: 'NBSYT',
    teacherCount: 1,
    studentCount: 26,
    teacherId: '200904',
  },
  {
    id: '2009014',
    name: 'English 10 Revision',
    code: 'VCTSA',
    teacherCount: 2,
    studentCount: 14,
    teacherId: '200904',
  },
  {
    id: '2009015',
    name: 'French 10B 🇫🇷',
    code: 'LEQIN',
    teacherCount: 1,
    studentCount: 17,
    teacherId: '200904',
  },
  {
    id: '2009016',
    name: 'French 10C 🇫🇷',
    code: 'UYTAV',
    teacherCount: 1,
    studentCount: 24,
    teacherId: '200904',
  },

  {
    id: '2009017',
    name: 'Music',
    type: 'Class',
    teacherCount: 2,
    studentCount: 22,
    teacherId: '200907',
  },
  {
    id: '2009018',
    name: 'Nautical Studies',
    type: 'Class',
    code: 'WERUH',
    teacherCount: 1,
    studentCount: 9,
    teacherId: '200908',
  },
  {
    id: '2009019',
    name: 'Spanish',
    type: 'Class',
    code: 'ALONW',
    teacherCount: 3,
    studentCount: 23,
    teacherId: '200908',
  },
  {
    id: '2009020',
    name: 'TheQuickBrownFoxJumpedOverTheLazyDogTheQuickBrownFoxJumpedOverTheLazyDogTheQuickBrownFoxJumpedOverTheLazyDogTheQuickBrownFoxJumpedOverTheLazyDogTheQuickBrownFoxJumpedOverTheLazyDog',
    code: 'TQBFJ',
    teacherCount: 2,
    studentCount: 13,
    teacherId: '200908',
  },
  {
    id: '2009021',
    name: 'Fine Arts',
    type: 'Class',
    teacherCount: 1,
    stundentCount: 12,
    teacherId: '200909',
  },
  {
    id: '2009022',
    name: 'Film and Media Studies',
    type: 'Class',
    teacherCount: 1,
    studentCount: 9,
    teacherId: '200910',
  },

  // Brazeau Elementary
  {
    id: '4002023',
    name: '5A Geography 🌍 (Y22)',
    code: 'E6IFL',
    teacherCount: 1,
    studentCount: 19,
    teacherId: '40203', // Hannah Khan
  },
  {
    id: '4002024',
    name: '5A Math ➕ (Y22)',
    code: 'GLOI4',
    teacherCount: 1,
    studentCount: 19,
    teacherId: '40203',
  },
  {
    id: '4002025',
    name: '5A Language Arts 🖋 (Y22)',
    code: '1KXFS',
    teacherCount: 1,
    studentCount: 19,
    teacherId: '40203',
  },
  {
    id: '4002026',
    name: '5A Science 🧪 (Y22)',
    code: 'ZOLXB',
    teacherCount: 1,
    studentCount: 19,
    teacherId: '40203',
  },
  {
    id: '4002027',
    name: '5A History 📖 (Y22)',
    code: 'W5SUL',
    teacherCount: 1,
    studentCount: 19,
    teacherId: '40203',
  },
  {
    id: '4002028',
    name: '5A 5B Physical Education 🏀 (Y22)',
    code: 'H1SLO',
    teacherCount: 2,
    studentCount: 37,
    teacherId: '40203',
  },

  // City College
  {
    id: '4002029',
    name: 'Software Development 101',
    code: 'A2B2C',
    teacherCount: 1,
    studentCount: 25,
    studentId: '200966', // Kim Franco
    purchaserId: '10003',
  },
];
